/**
 * @author      yewon@zumper.com (Yewon Lee)
 * @copyright   Copyright (c) 2018, Zumper
 * @description Configure message for multi message
 */

import type { InitialMessageData, Listable, MessageDataForMulti, Property } from '@zcode/state-type'
import type { Mutable } from '@zcode/utility-types'

const configureForMultiMsg = (
  messageData: Mutable<InitialMessageData>,
  entity: Listable | Property,
  multiListables: readonly Listable[]
): asserts messageData is Mutable<MessageDataForMulti> => {
  const listingIds: number[] = []
  const messagedBuildingIds: number[] = []
  // need this hash map to properly store sent message when multi message fails to send message
  // to all the buildings/listings
  const messagedFpToBldgMap: Record<number, number> = {}
  const messagedListingIds: number[] = []

  // track messaged listings/buildings
  if (multiListables) {
    for (const listable of multiListables) {
      listingIds.push(listable.listingId)
      if (listable.buildingId) {
        messagedBuildingIds.push(listable.buildingId)
        messagedFpToBldgMap[listable.listingId] = listable.buildingId
      } else {
        messagedListingIds.push(listable.listingId)
      }
    }
  }
  const config: Pick<
    Mutable<MessageDataForMulti>,
    | 'listingIds'
    | 'messagedBuildingIds'
    | 'messagedFpToBldgMap'
    | 'messagedListingIds'
    | 'originalTarget'
  > = {
    listingIds,
    messagedBuildingIds,
    messagedFpToBldgMap,
    messagedListingIds,
    originalTarget: entity,
  }
  Object.assign(messageData, config)
}

export default configureForMultiMsg
